import { useEffect, useRef, useState } from 'react';
import { IconCalendarTime, IconPackage, IconPlus } from '@tabler/icons-react';
import { useProfile } from '@shared/api/useProfile';
import { useSlotOfferModal } from '../../model/use-slot-offer-modal';
import { usePackageOfferModal } from '../../model/use-package-offer-modal';
import s from './send-offer-button.module.scss';

// Кнопка «+» с меню предложений — видна только преподавателю
export const SendOfferButton = ({ chatId, disabled }) => {
  const { data: profile } = useProfile();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const { open: openSlotModal } = useSlotOfferModal();
  const { open: openPackageModal } = usePackageOfferModal();

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  if (profile?.role !== 'teacher') return null;

  const handleSelect = (openModal) => {
    setIsOpen(false);
    openModal({ chatId });
  };

  return (
    <div className={s.offerWrapper} ref={wrapperRef}>
      {isOpen && (
        <div className={s.menu}>
          <button
            type="button"
            className={s.menuItem}
            onClick={() => handleSelect(openSlotModal)}
          >
            <IconCalendarTime size={18} />
            Предложить слот
          </button>
          <button
            type="button"
            className={s.menuItem}
            onClick={() => handleSelect(openPackageModal)}
          >
            <IconPackage size={18} />
            Предложить пакет
          </button>
        </div>
      )}
      <button
        type="button"
        className={s.offerBtn}
        onClick={() => setIsOpen((prev) => !prev)}
        disabled={disabled}
        aria-label="Предложить занятие или пакет"
      >
        <IconPlus size={20} />
      </button>
    </div>
  );
};
